import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5999992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-brand" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Marca", -1))
const _hoisted_3 = { id: "dropItem" }
const _hoisted_4 = ["id", "value", "onUpdate:modelValue", "onChange"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allBrands" }, "Todas Unidades", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedValue, (brand) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "d-flex",
          key: brand.code,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.eventStop && _ctx.eventStop(...args)))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checked-input",
            id: brand.name,
            value: brand.checked,
            "onUpdate:modelValue": ($event: any) => ((brand.checked) = $event),
            onChange: ($event: any) => (_ctx.changeFilter(brand))
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, brand.checked]
          ]),
          _createElementVNode("label", {
            for: brand.name
          }, _toDisplayString(brand.name), 9, _hoisted_5)
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "checked-input",
          id: "allBrands",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.allBrands) = $event)),
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeAllBrands && _ctx.changeAllBrands(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.allBrands]
        ]),
        _hoisted_7
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}